import Echo from 'laravel-echo'
import PusherModule from 'pusher-js'
const Pusher = PusherModule.Pusher || PusherModule
import { API_URL } from '@/config'

const backendUrl = API_URL.replace(/\/api\/?$/, '')

let echoInstance = null

export function getEcho() {
  if (echoInstance) return echoInstance
  return null
}

export function initEcho(token) {
  if (echoInstance) {
    echoInstance.disconnect()
    echoInstance = null
  }

  const key = import.meta.env.VITE_PUSHER_APP_KEY
  if (!key) return null

  const pusherClient = new Pusher(key, {
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'mt1',
    forceTLS: true,
    encrypted: true,
    authEndpoint: `${backendUrl}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    },
  })

  echoInstance = new Echo({
    broadcaster: 'pusher',
    key,
    client: pusherClient,
  })

  return echoInstance
}

export function destroyEcho() {
  if (echoInstance) {
    echoInstance.disconnect()
    echoInstance = null
  }
}

export default { getEcho, initEcho, destroyEcho }
